var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "196px",
    viewBox: "0 0 123 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifiche-Web-|-Drawer-Shell-V2-light-all-cases-4---icons-empty-7",
    transform: "translate(-1605.000000, -185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1605.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F2F5F8",
    x: 0,
    y: 0,
    width: 110,
    height: 28.3333333,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(9.000000, 8.500000)",
    fill: "#C9D9E8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 52,
    height: 4.25,
    rx: 2.125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    fillRule: "nonzero",
    x: 0,
    y: 7.08333333,
    width: 34.9041096,
    height: 4.25,
    rx: 2.125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(91.244275, 7.166667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#C9D9E8",
    fillRule: "nonzero",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 7,
    cy: 7,
    r: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row-Copy",
    transform: "translate(0.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F2F5F8",
    x: 0,
    y: 0,
    width: 110,
    height: 28.3333333,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(9.000000, 8.500000)",
    fill: "#C9D9E8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 52,
    height: 4.25,
    rx: 2.125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    fillRule: "nonzero",
    x: 0,
    y: 7.08333333,
    width: 34.9041096,
    height: 4.25,
    rx: 2.125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(91.244275, 7.166667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#C9D9E8",
    fillRule: "nonzero",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 7,
    cy: 7,
    r: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row-Copy-2",
    transform: "translate(0.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F2F5F8",
    x: 0,
    y: 0,
    width: 110,
    height: 28.3333333,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(9.000000, 8.500000)",
    fill: "#C9D9E8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 52,
    height: 4.25,
    rx: 2.125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    fillRule: "nonzero",
    x: 0,
    y: 7.08333333,
    width: 34.9041096,
    height: 4.25,
    rx: 2.125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(91.244275, 7.166667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#C9D9E8",
    fillRule: "nonzero",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 7,
    cy: 7,
    r: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(75.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#005075",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.021342,33.0875418 L35.0750195,19.0338186 C35.2946997,18.8141842 35.2946997,18.4579991 35.0750195,18.2383188 L33.7492475,16.9125011 C33.5295672,16.6928666 33.1734279,16.6928666 32.9537477,16.9125011 L20.6235921,29.2426566 L16.0930701,24.7121346 C15.8733898,24.4924543 15.5172506,24.4924543 15.2975245,24.7121346 L13.9717525,26.0379066 C13.7520723,26.2575868 13.7520723,26.6137261 13.9717525,26.8334521 L20.2258422,33.0875418 C20.4454767,33.3071763 20.801616,33.3071763 21.021342,33.0875418 Z",
    id: "c",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.808256,50.9470313 C82.1345223,48.0276562 77.131651,43.6359375 77.131651,29.25 C77.131651,18.3234375 69.592054,9.5765625 59.4257766,7.430625 L59.4257766,4.5 C59.4257766,2.01515625 57.444003,0 55,0 C52.555997,0 50.5742234,2.01515625 50.5742234,4.5 L50.5742234,7.430625 C40.407946,9.5765625 32.868349,18.3234375 32.868349,29.25 C32.868349,43.6359375 27.8654777,48.0276562 25.191744,50.9470312 C24.3613919,51.8540625 23.9932692,52.9382812 24.0000931,54 C24.0154119,56.30625 25.7965171,58.5 28.4425724,58.5 L81.5574276,58.5 C84.2034829,58.5 85.985972,56.30625 85.9999069,54 C86.0067308,52.9382812 85.6386081,51.8526562 84.808256,50.9470312 L84.808256,50.9470313 Z M33.3458015,51.75 C36.28248,47.8167187 39.4931748,41.2973438 39.5083979,29.3315625 C39.5083979,29.3034375 39.5000944,29.278125 39.5000944,29.25 C39.5000944,20.5509375 46.43907,13.5 55,13.5 C63.56093,13.5 70.4999056,20.5509375 70.4999056,29.25 C70.4999056,29.278125 70.4916021,29.3034375 70.4916021,29.3315625 C70.5068252,41.29875 73.71752,47.818125 76.6541985,51.75 L33.3458015,51.75 Z M55,72 C59.888006,72 63.8529372,67.9710938 63.8529372,63 L46.1470628,63 C46.1470628,67.9710938 50.111994,72 55,72 Z",
    id: "Shape",
    fill: "#E4EAF0",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/empty_notification.7154f1f0d5ca9e202d2cc0879a20fd47.svg";
export { ForwardRef as ReactComponent };